var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "page"
  }, [_vm.getModuleConfig('staff_bind_success_page.form_title') ? _c('div', {
    staticClass: "page__title"
  }, [_vm._v(" " + _vm._s(_vm.getModuleConfig("staff_bind_success_page.form_title")) + " ")]) : _vm._e(), _vm.getModuleConfig('staff_bind_success_page.form_desc') ? _c('div', {
    staticClass: "page__desc"
  }, [_vm._v(" " + _vm._s(_vm.getModuleConfig("staff_bind_success_page.form_desc")) + " ")]) : _vm._e(), _vm.getModuleConfig('staff_bind_success_page.content') ? _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.getModuleConfig('staff_bind_success_page.content'))
    }
  }) : _vm._e(), _vm._l(_vm.contentImages, function (image) {
    return _c('img', {
      key: image.order,
      staticClass: "w-100",
      attrs: {
        "src": image.image_url
      }
    });
  }), _vm.getModuleConfig('staff_bind_success_page.content_url') ? _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.getModuleConfig('staff_bind_success_page.content_url'))
    }
  }) : _vm._e()], 2), _c('div', {
    staticClass: "page__button s-space-y-4"
  }, [_c('MemberButton', {
    attrs: {
      "button-text": _vm.getModuleConfig('staff_bind_success_page.button_text'),
      "button-url": _vm.getModuleConfig('staff_bind_success_page.button_url'),
      "type": _vm.getModuleConfig('staff_bind_success_page.button_action')
    }
  })], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }